import React from "react";
import {
  IEditIntakeWizardConfigs,
  IWizardConfig,
  SubmitButtonColor,
} from "../../../wizard/types";
import deactivateFormValidator from "../validators/deactivateFormValidator";
import DeactivateContent from "../../../../components/DeactivateContent/DeactivateContent";
import DeleteContent from "../../components/DeleteContent";
import { ENTITY_NAMES } from "../../../../constants";

export function useEditIntakeConfig(): IEditIntakeWizardConfigs {
  const getDeactivateConfig = ({ approved, pending }): IWizardConfig => ({
    steps: [
      {
        titleConfig: {
          titleText: "Deactivate intake",
        },
        width: "552px",
        content: () => <DeactivateContent name={ENTITY_NAMES.intake} />,
        validator: deactivateFormValidator,
      },
    ],
    submitButtonText: "Deactivate",
    submitButtonColor: SubmitButtonColor.Danger,
    cancelButtonText: "Close",
    showSuccessNotification: false,
    saveCallback: async (data) => ({
      data: {
        reason: data.reason,
      },
    }),
    getInitialData: async () => ({ injectedData: { approved, pending } }),
  });

  const getDeleteIntakeConfig = ({ approved, pending }): IWizardConfig => ({
    steps: [
      {
        width: "430px",
        titleConfig: {
          titleText: "Delete intake",
        },
        content: () => <DeleteContent name={ENTITY_NAMES.intake} />,
      },
    ],
    getInitialData: async () => ({ injectedData: { approved, pending } }),
    submitButtonText: null,
  });

  return {
    getDeactivateConfig,
    getDeleteIntakeConfig,
  };
}
